import { useCallback, useState } from "react";

export function useCapsLock() {
  const [isCapsLockOn, setIsCapsLockOn] = useState(false);

  const handleKeyEvent = useCallback((e: React.KeyboardEvent<HTMLElement>) => {
    setIsCapsLockOn(e.getModifierState("CapsLock"));
  }, []);

  return {
    isCapsLockOn,
    capsLockProps: {
      onKeyDown: handleKeyEvent,
      onKeyUp: handleKeyEvent,
    },
  };
}
